module.exports = __webpack_public_path__ + "img/up.d6ea72d4.svg";